<template>
    <div >
      <a-affix class="kefu" :style="{ position: 'absolute', top: '138px', right: 0}">

        <div class="main-box">
          <div class="first-box">
            <img
              src="~@/assets/images/basic/niu.png"
            />
          </div>
          <div class="second-box">
            <a-menu class="mai" >
              <a-menu-item @click.native="kefu" @mouseover="showMai" @mouseleave="hideMai">
                <img
                v-show="!isMaiShow"
                  class="label9"
                  referrerpolicy="no-referrer"
                  src="~@/assets/images/basic/mai.png"
                />
                <img
                 v-show="isMaiShow"
                  class="label9"
                  referrerpolicy="no-referrer"
                  src="~@/assets/images/basic/mai_1.png"
                />
                <span class="info16">在线客服</span>
              </a-menu-item>
            </a-menu>
            <div  class="block5 flex-col daodan" @mouseover="showWeixin" @mouseleave="hideWeixin">
              <div class="box18 flex-col justify-between">
                <img
                  v-show="!isWeixinShow"
                  class="label9"
                  referrerpolicy="no-referrer"
                  src="~@/assets/images/basic/wechat.png"
                />
                 <img
                   v-show="isWeixinShow"
                  class="label9"
                  referrerpolicy="no-referrer"
                  src="~@/assets/images/basic/wechat_2.png"
                />
                <span class="info16">导单咨询</span>
              </div>
              <div v-show="isWeixinShow" class="daodan-ort">
                <p>专属客服</p>
                <div></div>
              </div>
            </div>
            <div class="block5 flex-col kefu" @mouseover="showPhone" @mouseleave="hidePhone">
              <div class="box18 flex-col justify-between">
                <img
                  v-show="!isPhoneShow"
                  class="label9"
                  referrerpolicy="no-referrer"
                  src="~@/assets/images/basic/phone.png"
                />
                <img
                  v-show="isPhoneShow"
                  class="label9"
                  referrerpolicy="no-referrer"
                  src="~@/assets/images/basic/phone_3.png"
                />
                <span class="info16">客服热线</span>
              </div>
              <div v-show="isPhoneShow"  class="orts_kefu">
                <p>客服热线</p>
                <div>400-999-8591</div>
              </div>
            </div>
          </div>
          <div  class="third-box">
            <div class="box18 flex-col justify-between" @click="getTop">
              <img
                class="label9"
                referrerpolicy="no-referrer"
                src="~@/assets/images/basic/totop.png"
              />
              <span class="word34">回到顶部</span>
            </div>
          </div>
        </div>
      </a-affix>
      <ke-fu ref="kefu" ></ke-fu>
    </div>
</template>

<script>
import KeFu from '@/components/common/KeFu.vue'

export default {
    name: 'KefuTools',
    components: {
      KeFu
    },
    created() {
    },
    mounted() {

    },
    data () {
      return {
        isWeixinShow:false,
        isPhoneShow:false,
        isMaiShow:false
      };
    },
    methods:{
      showMai(){
        this.isMaiShow=true
      },
      hideMai(){
        this.isMaiShow=false
      },
      showWeixin(){
        this.isWeixinShow = true;
      },
      hideWeixin(){
        this.isWeixinShow = false;
      },
      showPhone(){
        this.isPhoneShow = true;
      },
      hidePhone(){
        this.isPhoneShow = false;
      },
      getTop(){
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
      },
      kefu(){
        // this.$kefu();
        this.$refs.kefu.open();
      },
    }
}
</script>

<style scoped>
.main-box{
  height: 316px;
  width: 68px;
  margin: 0;
}
.first-box{
  width: 50px;
  height: 50px;
  margin-bottom: -8px;
  z-index: 10;
  margin-left: 9px;
}
.second-box{
  width: 68px;
  height: auto;
  text-align: center;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.12);
  border-radius: 6px 0 0 6px;
}
.third-box{
  width: 68px;
  height: 64px;
  background: #FFFFFF;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.12);
  border-radius: 4px 0 0 4px;
  margin-top: 10px;
}
.block5 {
  height: 64px;
  background-color: rgba(255, 255, 255, 1);
  width: 68px;
}

.box18 {
  width: 48px;
  height: 44px;
  padding: 10px 0 0 10px;
}
/deep/ .ant-menu-item{
  height: 64px !important ;
  background-color: rgba(255, 255, 255, 1);
  width: 68px !important;
  line-height: 30px !important;
  padding: 10px 0 0 10px !important;
}
/deep/ .ant-menu-item:hover,.block5:hover{
  background: linear-gradient(to right,rgb(255, 138, 7) 30%,rgb(255, 95, 2));
}
/deep/ .ant-menu-item:hover,.block5:hover span{
  color: #fff !important;
}
/deep/ .ant-menu-item img{
  margin: 0;
  margin-left: -10px;
}
/deep/ .ant-menu-vertical .ant-menu-item, .ant-menu-vertical-left .ant-menu-item, .ant-menu-vertical-right .ant-menu-item, .ant-menu-inline .ant-menu-item, .ant-menu-vertical .ant-menu-submenu-title, .ant-menu-vertical-left .ant-menu-submenu-title, .ant-menu-vertical-right .ant-menu-submenu-title, .ant-menu-inline .ant-menu-submenu-title{
  margin: 0;
}
/deep/ .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected{
  background-color: #ffffff;
}
.mai:hover span{
  color: #fff;
}
.label9 {
  width: 24px;
  height: 24px;
  margin-left: 12px;
}
.info16 {
  width: 48px;
  height: 17px;
  display: block;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 12px;
  font-family: AlibabaPuHuiTiR;
  white-space: nowrap;
  line-height: 17px;
  text-align: center;
  margin-top: 3px;
}

.word34 {
  width: 48px;
  height: 17px;
  display: block;
  overflow-wrap: break-word;
  color: rgba(253, 89, 2, 1);
  font-size: 12px;
  font-family: AlibabaPuHuiTiR;
  white-space: nowrap;
  line-height: 17px;
  text-align: center;
  margin-top: 3px;
}

.daodan{
  position: relative;
}
.daodan .daodan-ort{
  width: 160px;
  height: 180px;
  background: url("~@/assets/images/basic/bg_qr.png") no-repeat center;
  background-size: auto 100%;
  position: absolute;
  right: 55px;
  top:-60px;
  overflow: hidden;
}
.daodan-ort > p {
  width: auto;
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  font-weight: 400;
  margin: 34px 0 4px 33px;
  text-align: left;
}
.daodan-ort > div {
  width: 88px;
  height: 88px;
  margin-left: 33px;
  background: url("~@/assets/images/basic/qr.png") no-repeat center;
  background-size: auto 100%;
}
.orts_kefu {
  width: 200px;
  height: 114px;
  background: url("~@/assets/images/basic/order.png") no-repeat center;
  background-size: auto 100%;
  position: absolute;
  top: 145px;
  right: 55px;
  overflow: hidden;
}
.orts_kefu > p {
  width: auto;
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  font-weight: 400;
  margin: 34px 0 4px 33px;
  text-align: left;
}
.orts_kefu>div {
  width: auto;
  height: 25px;
  line-height: 25px;
  margin-left: 33px;
  font-size: 16px;
  font-weight: 600;
  text-align: left;
}
.kefu{
  z-index: 88;
}
</style>



// WEBPACK FOOTER //
// src/components/common/KefuTools.vue